import Vue from 'vue'
import api from '@/api/api'
import {heroCatalog, setHeroCatalog} from '@/common/mlbbBroadcast'

// хелперы читают справочник напрямую — делаем его реактивным, чтобы картинки появились после загрузки
Vue.observable(heroCatalog)

let loading = null

/** Справочник героев грузим один раз на вкладку; после ошибки следующий вызов пробует снова */
export function loadHeroCatalog() {
    if (!loading) {
        loading = api.mlbbEsports.heroes({skipErrorToast: true})
            .then((res) => setHeroCatalog(res?.data?.data))
            .catch(() => {
                loading = null
            })
    }
    return loading
}
